export default {
    computed: {
        _selfUrls() {
            const listUrl = 'self';

            return {
                list: () => listUrl + '/',
            }
        },
        _patientUrls() {
            const listUrl = 'patient';
            const detailUrl = id => `${listUrl}/${id}`;

            return {
                list: () => listUrl + '/',

                detail: detailUrl,
            };
        },
        _visitUrls() {
            const listUrl = 'visit';
            const detailUrl = id => `${listUrl}/${id}`;

            return {
                list: () => listUrl + '/',
                listFreeTerms: (specId, docId, depIds, dateStart, timeStart, timeEnd, lastShownTerm) => {
                    let depIdsQuery = '';
                    for (let id = 0; id < depIds.length; id++) {
                        depIdsQuery = depIdsQuery + `&departments_ids=` + depIds[id];
                    }
                    let url = `${listUrl}/free_terms/?${depIdsQuery}` +
                        `&date_start=${dateStart}&time_start=${timeStart}&time_end=${timeEnd}`;
                    if (specId)
                        url += `&specialty_id=${specId}`;
                    if (docId)
                        url += `&doctor_id=${docId}`;
                    if (lastShownTerm)
                        url += `&last_shown_term=${lastShownTerm}`;
                    return url;
                },
                listReserveFreeTerm: () => `${listUrl}/reserve_free_term/`,

                detail: detailUrl,
            }
        },
        _facilityUrls() {
            const detailUrl = (id) => `facility/${id}`;

            return {
                detail: id => detailUrl(id) + '/',
                detailCities: id => `${detailUrl(id)}/cities/`,
                detailDepartments: id => `${detailUrl(id)}/departments/`,
                detailSpecialtiesForCity: (id, city) => `${detailUrl(id)}/specialties_for_city/?city=${city}`,
                detailDepartmentsForSpecialty: (id, city, specId) => {
                    let url = `${detailUrl(id)}/departments_for_specialty/?city=${city}`;
                    if (specId)
                        url += `&specialty_id=${specId}`;
                    return url;
                },
                detailDoctors: (id, specId, depIds) => {
                    let url = detailUrl(id) +
                        `/possible_doctors_for_departments_and_specialty/?departments_ids=${depIds}`;
                    if (specId)
                        url += `&specialty_id=${specId}`;
                    return url;
                },
                detailRegisterPatient: id => `${detailUrl(id)}/register_patient/`,
                detailCheckEmailUniqueness: id => `${detailUrl(id)}/check_email_uniqueness/`,
            };
        },
        $api() {
            // Everything is a function here!
            return {
                login: () => 'login/',
                logout: () => 'logout/',

                self: this._selfUrls,
                patient: this._patientUrls,
                visit: this._visitUrls,
                facility: this._facilityUrls,
            }
        },
    },
}



// WEBPACK FOOTER //
// ./src/mixins/ApiMixin.js